import type { FulfillmentOrderLine } from "../../types";
import { ticketVisitForLine, type TicketVisit } from "../../service/confirmationTicketWorkspace";
import { ConfirmationButton } from "./primitives";
import "./ticketWorkspace.css";

type Props = {
  visits: readonly TicketVisit[];
  lines: readonly FulfillmentOrderLine[];
  dirtyVisitIds?: readonly string[];
  disabled?: boolean;
  editDisabled?: boolean;
  onOpen: (id: string) => void;
  onEdit?: (line: FulfillmentOrderLine) => void;
};

/** 展示完整行程考察点，并保留无法唯一关联的历史门票入口。 */
export function ConfirmationTicketPoints({ visits, lines, dirtyVisitIds = [], disabled, editDisabled, onOpen, onEdit }: Props) {
  const counts = new Map<string, number>();
  const unlinked: FulfillmentOrderLine[] = [];
  for (const line of lines) {
    if (line.status !== "active" || line.resourceType !== "考察点") continue;
    const visit = ticketVisitForLine(line, visits);
    if (visit) counts.set(visit.id, (counts.get(visit.id) ?? 0) + 1);
    else unlinked.push(line);
  }
  const dirty = new Set(dirtyVisitIds);
  return <section className="confirmation-ticket-points" aria-label="行程考察点">
    <header className="confirmation-ticket-points-heading"><h2>行程考察点</h2><span>{visits.length} 次到访 · 选择考察点录入或修改费用</span></header>
    {visits.length ? <div className="confirmation-ticket-point-grid">
      {visits.map(visit => <button type="button" key={visit.id} className="confirmation-ticket-point-card" disabled={disabled} onClick={() => onOpen(visit.id)} aria-label={`录入${visit.name} D${visit.dayNo} ${visit.date ?? "日期待补充"}`}>
        <strong>{visit.name}</strong>
        <span className="confirmation-ticket-point-date">D{visit.dayNo} · {visit.date ?? "日期待补充"}</span>
        <span className="confirmation-ticket-point-status"><span data-entered={Boolean(counts.get(visit.id))}>已录入 {counts.get(visit.id) ?? 0} 条</span>{dirty.has(visit.id) && <span className="confirmation-ticket-point-draft">草稿待应用</span>}</span>
      </button>)}
    </div> : <p className="confirmation-ticket-points-empty">当前行程暂无考察点，请先在行程中补充。</p>}
    {unlinked.length > 0 && <div className="confirmation-ticket-unlinked" role="status">
      <p>另有 {unlinked.length} 条门票费用待关联行程到访，已保留在确认行池中。请选择对应行程点核对。</p>
      <div>{unlinked.map(line => <ConfirmationButton key={line.id} variant="ghost" size="sm" disabled={editDisabled || !onEdit} onClick={() => onEdit?.(line)}>关联第 {line.lineNo} 行 · {line.itemNameSnapshot}</ConfirmationButton>)}</div>
    </div>}
  </section>;
}
